<template>
  <v-layout fill-height class="login-wrapper">
    <v-img 
      src="../../assets/images/login2.jpg" 
      gradient="to bottom, rgba(26, 35, 126, .85), rgba(10, 10, 10, .95)"
      class="align-center justify-center"
      height="100vh"
    >
      <v-container>
        <v-row justify="center">
          <v-col cols="12" sm="8" md="5" lg="4">
            
            <v-card elevation="24" class="login-card pa-8 py-10 text-center">
              <div class="d-flex justify-center mb-4">
                <v-avatar size="85" class="logo-box">
                  <v-img
                    src="../../assets/images/W.png"
                    contain
                    alt="Whale Shark Logo"
                  ></v-img>
                </v-avatar>
              </div>
              
              <h1 class="brand-text white--text mb-1">WHALE SHARK</h1>
              <p class="overline cyan--text text--lighten-3 mb-8 tracking-widest">
                Management Portal
              </p>

              <v-form ref="form" @submit.prevent="validateInput">
                <div class="text-left mb-1 blue--text text--lighten-4 caption font-weight-bold text-uppercase">
                  Administrator ID
                </div>
                <v-text-field
                  v-model="phone"
                  placeholder="Enter Phone Number"
                  outlined
                  dark
                  dense
                  prepend-inner-icon="mdi-account"
                  color="cyan lighten-3"
                  class="custom-input mb-2"
                ></v-text-field>

                <div class="text-left mb-1 blue--text text--lighten-4 caption font-weight-bold text-uppercase">
                  Password
                </div>
                <v-text-field
                  v-model="password"
                  :type="showPassword ? 'text' : 'password'"
                  placeholder="Enter Password"
                  outlined
                  dark
                  dense
                  prepend-inner-icon="mdi-lock"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showPassword = !showPassword"
                  color="cyan lighten-3"
                  class="custom-input"
                ></v-text-field>

                <v-btn
                  block
                  x-large
                  depressed
                  color="#1A237E"
                  class="login-btn white--text mt-8 text-none font-weight-black"
                  :loading="loading"
                  @click="validateInput"
                >
                  Authorize Access
                  <v-icon right small>mdi-arrow-right</v-icon>
                </v-btn>
              </v-form>

              <div class="mt-12">
                <p class="caption grey--text text--lighten-1 mb-0">Developed and Managed by</p>
                <p class="caption cyan--text text--lighten-4 font-weight-bold text-uppercase">
                  Leopard Tech Labs Private Limited
                </p>
              </div>
            </v-card>

          </v-col>
        </v-row>
      </v-container>

      <v-snackbar v-model="showSnackBar" :timeout="timeout" color="red darken-4" elevation="10">
        <v-icon left>mdi-alert-circle</v-icon>
        {{ msg }}
      </v-snackbar>
    </v-img>
  </v-layout>
</template>

<script>
import axios from "axios";
import store from './../../store'

export default {
  data() {
    return {
      phone: '',
      password: '',
      showPassword: false,
      loading: false,
      showSnackBar: false,
      timeout: 4000,
      msg: '',
    };
  },
  methods: {
    validateInput() {
      if (!this.phone || !this.password) {
        this.msg = "Unauthorized: Please provide full credentials";
        this.showSnackBar = true;
        return;
      }
      this.login();
    },
    async login() {
  this.loading = true;
  try {
    const response = await axios.post("/user/login/password", {
      phone: this.phone,
      password: this.password
    });
    
    if (response.data.status) {
      localStorage.setItem("token", response.data.data.token);
      store.commit("userType", response.data.data.role);
      store.commit("userData", response.data.data);
      
      // FIX: Add .catch to handle the navigation guard redirection
      this.$router.push("/admin").catch(err => {
        if (err.name !== 'NavigationDuplicated' && !err.message.includes('Redirected')) {
          console.error(err);
        }
      });
    } else {
      this.msg = response.data.msg || "Invalid Credentials";
      this.showSnackBar = true;
    }
  } catch (err) {
    this.msg = "Secure Server Unreachable. Check connection.";
    this.showSnackBar = true;
  } finally {
    this.loading = false;
  }
}
  }
};
</script>

<style scoped>
/* Glassmorphism Card Style */
.login-card {
  background: rgba(255, 255, 255, 0.07) !important;
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
  border-radius: 28px !important;
}

.logo-box {
  background: rgba(255, 255, 255, 0.08);
  padding: 10px;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.brand-text {
  font-family: 'Syne', sans-serif;
  font-weight: 800;
  letter-spacing: 4px;
  font-size: 26px;
  line-height: 1.2;
}

/* Custom Field Styling to blend with dark theme */
.custom-input >>> .v-input__slot {
  background: rgba(0, 0, 0, 0.25) !important;
  border-radius: 12px !important;
}

.login-btn {
  border-radius: 14px !important;
  letter-spacing: 1.5px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3) !important;
}

.tracking-widest {
  letter-spacing: 4px !important;
}

.login-wrapper {
  overflow: hidden;
}
</style>